import React from 'react'
import { Link } from 'react-router-dom'
import { Donut } from '@softwaredev_cegeka/stix-chart'
import { Card } from '@softwaredev_cegeka/stix-core/dist/components'
import vars from '@softwaredev_cegeka/stix-core/styles/theme-vars-exports.scss'

import './homePageWidgets.scss'
import { AuthApi } from 'src/api/authApi'
import { authenticatedUserStore } from 'src/stores'

class MostPopularGroups extends React.Component {
    pieStatusTheme = {
        colors: [
            '#e95766',
            '#ffbb4d',
            '#7DCDD2',
            '#4c9fce',
            vars['theme-color-primary'],
        ],
    }

    state = {
        groups: [],
    }

    authClient = new AuthApi(authenticatedUserStore.authToken)

    componentDidMount() {
        this.fetchAndStoreGroups()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            prevProps.selectedOrganization !== this.props.selectedOrganization
        ) {
            this.fetchAndStoreGroups()
        }
    }

    componentWillUnmount() {
        this.authClient.cancelRequest()
    }

    fetchAndStoreGroups = () => {
        this.setState({ loading: true })
        this.authClient
            .fetchGroupsCounted(
                {
                    elements: 5,
                    field: '-users',
                },
                authenticatedUserStore.selectedOrganization?.id
            )
            .then(response => {
                this.setState({
                    groups: response?.data?.results.map(group => ({
                        id: group.group_name,
                        label: group.group_name,
                        value: group.number_of_users,
                    })),
                })
            })
    }

    render() {
        return (
            <div className="popular-groups">
                <Card>
                    <Card.Header>Most popular groups</Card.Header>

                    <div className="popular-groups-chart">
                        <Donut
                            height={110}
                            width={120}
                            data={this.state.groups}
                            theme={this.pieStatusTheme}
                            legendPosition={'left'}
                        />
                    </div>

                    <Card.Footer>
                        <Link to={'/groups'}>View all groups</Link>
                    </Card.Footer>
                </Card>
            </div>
        )
    }
}

export default MostPopularGroups
